module.exports = __webpack_public_path__ + "static/img/123_03.86eaf4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/123_03.png
// module id = 62Fa
// module chunks = 1